import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
var Tooltip = function (_a) {
    var children = _a.children, content = _a.content, _b = _a.position, position = _b === void 0 ? 'auto' : _b;
    var _c = useState(false), isVisible = _c[0], setIsVisible = _c[1];
    var _d = useState(position), autoPosition = _d[0], setAutoPosition = _d[1];
    var containerRef = useRef(null);
    var tooltipRef = useRef(null);
    var positions = {
        top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
        bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
        left: 'right-full top-1/2 -translate-y-1/2 mr-2',
        right: 'left-full top-1/2 -translate-y-1/2 ml-2'
    };
    useEffect(function () {
        if (isVisible && containerRef.current && tooltipRef.current) {
            var container = containerRef.current.getBoundingClientRect();
            var tooltip = tooltipRef.current.getBoundingClientRect();
            var viewport = {
                top: 0,
                right: window.innerWidth,
                bottom: window.innerHeight,
                left: 0
            };
            // Calculate available space in each direction
            var space = {
                top: container.top - tooltip.height,
                right: viewport.right - (container.right + tooltip.width),
                bottom: viewport.bottom - (container.bottom + tooltip.height),
                left: container.left - tooltip.width
            };
            // Find the direction with most space
            var bestPosition_1 = 'top';
            var maxSpace_1 = space.top;
            Object.entries(space).forEach(function (_a) {
                var pos = _a[0], amount = _a[1];
                if (amount > maxSpace_1) {
                    maxSpace_1 = amount;
                    bestPosition_1 = pos;
                }
            });
            setAutoPosition(bestPosition_1);
        }
    }, [isVisible]);
    return (React.createElement("div", { ref: containerRef, className: "relative inline-block", onMouseEnter: function () { return setIsVisible(true); }, onMouseLeave: function () { return setIsVisible(false); } },
        children,
        React.createElement(AnimatePresence, null, isVisible && (React.createElement(motion.div, { ref: tooltipRef, initial: { opacity: 0, scale: 0.9 }, animate: { opacity: 1, scale: 1 }, exit: { opacity: 0, scale: 0.9 }, className: "absolute ".concat(positions[autoPosition], " z-50 px-2 py-1 text-xs text-white bg-gray-800 rounded whitespace-nowrap") }, content)))));
};
export default Tooltip;
